module.exports = __webpack_public_path__ + "assets/img/4_317_big.42f17a75.jpg";